import Vue from 'vue'
import Vuex from 'vuex'
import pathify, { make } from 'vuex-pathify'

const state = {
  invoicemodal: false,
  openpaymodal: false,
  // prepaidmodal: false,
  currentinvoiceno: '',
  currentsvnumber: '',
  currentstart_date: '',
  currentend_date: '',
  totalpaymodal: false,
  currenttotalpay: [],
  totalpricepay: '',
  transactionmodal: false,
  currenttransaction: '',
  invoiceoftransaction: false,
  typeofcompany: 'INET',
  totalExcVat: '',
  totalvatamount: '',
  tokenHashTaxid: '',
  invoicename: '',
  invoicetotal: '',
  invoicedata: [],
  fullname_th: '',
  statusupload: '',
  svnumber: '',
  periodmodal: false,
  periodmodaloftransaction: false,
  current_transref: '',
  tempwaitinglist: ''
}

const mutations = make.mutations(state)

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    pathify.plugin
  ],
  state,
  mutations
})
